import { createModel } from "nyax";
import { createViCodeAppListBaseModal } from "src/store/models/entity/vicodeApp/_shared";

export const ViCodeAppFavoriteListModel = createModel(
  class extends createViCodeAppListBaseModal() {
    public effects() {
      return {
        ...super.effects(),
        initial: async () => {
          this._initial({
            initialAction: (pageIndex: number, pageSize: number) =>
              this.dependencies.serviceClient.vicodeApp.getViCodeAppFavoriteList(
                {
                  offset: pageIndex * pageSize,
                  limit: pageSize,
                }
              ),
          });
        },
      };
    }
  }
);
